// src/pages/CourseTime/components/slides/layouts/WorkedExampleSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import NoDataFallback from '../common/NoDataFallback.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateWorkedExample
const WorkedExampleSlide = ({ slide, renderSpokenText, skipTitleSpeech, themeColor }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  const w = slide.WorkedExampleData;
  const accent = themeColor || '#3D5AFE';
  if (!w) {
    return (
      <NoDataFallback
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        renderContent={renderContent}
      />
    );
  }
  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
      {w.example_brief && (
        <S.PointText style={{ marginBottom: 12 }}>
          {renderContent('we_brief', w.example_brief)}
        </S.PointText>
      )}
      <ol style={{ paddingLeft: 20 }}>
        {(w.steps || []).map((st, idx) => (
          <li key={idx} style={{ marginBottom: 12 }}>
            <S.PointText>
              <strong>{st.step_label}</strong>
              {st.step_label && st.action ? ' — ' : ''}
              {renderContent(`we_act_${idx}`, st.action || '')}
            </S.PointText>
            {st.outcome && (
              <S.PointText style={{ fontStyle: 'italic', marginTop: 2 }}>
                → {renderContent(`we_out_${idx}`, st.outcome)}
              </S.PointText>
            )}
            {st.rationale && (
              <S.PointText style={{ fontSize: '0.9em', opacity: 0.8, marginTop: 2 }}>
                {renderContent(`we_rat_${idx}`, st.rationale)}
              </S.PointText>
            )}
          </li>
        ))}
      </ol>
      {w.conclusion && (
        <div style={{ borderLeft: `4px solid ${accent}`, background: `${accent}10`, padding: '10px 14px', borderRadius: 8, marginTop: 8 }}>
          <S.PointText><strong>Takeaway:</strong> {renderContent('we_concl', w.conclusion)}</S.PointText>
        </div>
      )}
    </S.SlideDescription>
  );
};

export default WorkedExampleSlide;
